import React, { useState, useEffect } from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import "react-bootstrap-typeahead/css/Typeahead.css";
import inventoryApi from "../api/inventoryApi";


const FilesEdit = (props) => {
    const [files, setFiles] = useState(props.file.row);
    useEffect(() => {
        if (props.table === "lead" && props.parent !== null && props.file !== null) {
            console.log('console.log(files);', files);
        }
    }, []);

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (props.table === "lead") {
            const result = await inventoryApi.saveFiles(files);
            if (result) {
                submitFiles();
            }
        }
    }
    const submitFiles = () => {
        props.submitFiles();
    };

    return (
        <Modal {...props} aria-labelledby="contained-modal-title-vcenter" centered>
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Edit Files
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form.Group controlId="formFile" className="mb-3">
                <Form.Group controlId="formBasicTitle">
                    <Form.Label
                        className="form-view-label"
                    >
                        Title
                    </Form.Label>
                    <Form.Control
                        type="text"
                        name="title"
                        placeholder="Enter title"
                        value={files.title}
                        onChange={(e) => setFiles({ ...files, [e.target.name]: e.target.value })}
                    />
                    
                </Form.Group>
                </Form.Group>
                <Form.Group controlId="formBasicDescription">
                    <Form.Label
                        className="form-view-label"
                    >
                        Description
                    </Form.Label>
                    <Form.Control
                        as="textarea"
                        name="description"
                        placeholder="Enter description"
                        value={files.description}
                        onChange={(e) => setFiles({ ...files, [e.target.name]: e.target.value })}
                    />
                    
                </Form.Group>
            </Modal.Body>
            <Modal.Footer>
                <div className="submit">
                    <Button variant="success" onClick={handleSubmit}>Submit</Button>
                </div>
                <Button onClick={props.onHide} variant="light">Close</Button>
            </Modal.Footer>
        </Modal>
    );
};
export default FilesEdit;
